import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { Room } from '@/core/models/room.model'

import { Topbar } from './Topbar'

type EmergencyInactiveViewProps = {
  emergencyRoom: Room
}

export function EmergencyInactiveView({ emergencyRoom }: EmergencyInactiveViewProps) {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '100%', overflow: 'hidden' }}>
      <Topbar emergencyRoom={emergencyRoom} />
      <Typography>{t('page.emergency.message.pdsNotInRoom')}</Typography>
    </Stack>
  )
}
